import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { auth } from '../../../firebase'
import cloudFunctions from '../../../Helpers/cloudFunctions'

export default function Normal({ poll, totalVotes, showResults, fetchAndSetPollData, pollID, cta, privatePoll }) {
    const [selectedOption, setSelectedOption] = useState(null)
    const navigate = useNavigate()
    const ShowRes = ({ option }) => {
        const barRef = useRef(null)
        useEffect(() => {
            setTimeout(() => {
                try {
                    barRef.current.classList.add("pollResultsFullWidth")
                } catch {
                    void 0
                }
            }, 100)
        }, [])
        return (
            <>
                <div style={{ width: ((option.votes / totalVotes) * 100) + "%", height: "100%", position: "absolute", left: 0, top: -3 }}>
                    <div ref={barRef} className='pollResultBar' style={{ width: 0, height: "100%" }}>

                    </div>
                </div>
                <div>
                    <p style={{ opacity: .6, color: (((option.votes / totalVotes) * 100) >= 100 ? "white" : "black") }}>{isNaN(((option.votes / totalVotes) * 100).toFixed(0)) ? 0 : ((option.votes / totalVotes) * 100).toFixed(0)}%</p>
                </div>
            </>
        )
    }
    return (
        <div className={`flex fdc`} style={{ gap: 20 }}>
            {poll.options.map((option, idx) => {
                return (
                    <div onClick={() => { !showResults ? setSelectedOption(option.option) : void 0 }} className={`pollOptionNormal ${option.option === selectedOption && !showResults ? "pollOptionNormalSelected" : ""} ${showResults && (((option.votes / totalVotes) * 100) > 20) ? "pollOptionRevealed" : ""} flex aic jcsb`}>
                        <div className='flex aic' style={{ gap: 10, zIndex: 20000 }}>
                            {!showResults
                                ? <input style={{ width: 15, height: 15 }} type="radio" checked={selectedOption === option.option} />
                                : null
                            }
                            <p>{option.option}</p>
                        </div>
                        {showResults
                            ? <ShowRes option={option} />
                            : null
                        }
                    </div>
                )
            })}
            <button className={`b5 flex aic jcc ${showResults || !auth.currentUser ? "disabled" : ""}`} style={{ gap: 10, marginTop: 15 }} onClick={() => {
                if (!auth.currentUser) {
                    return navigate("/login")
                }
                if (!selectedOption) {
                    toast.error("Select an option")
                } else {
                    const loader = toast.loading("Submitting your vote")
                    cloudFunctions.vote({
                        pollID: pollID,
                        option: selectedOption,
                        private: privatePoll
                    }).then((res) => {
                        const response = res.data
                        if (response.error) {
                            toast.update(loader, {
                                render: response.msg,
                                icon: "❌"
                            })
                        } else {
                            toast.update(loader, {
                                render: "Vote submitted!",
                                icon: "✔️"
                            })
                            if (cta) window.open(cta)
                            fetchAndSetPollData()
                        }
                    }).catch((err) => {
                        toast.update(loader, {
                            render: "Something went wrong!",
                            icon: "❌"
                        })
                    }).finally(() => {
                        setTimeout(() => {
                            toast.dismiss(loader)
                        }, 2000)
                    })
                }
            }}>
                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24.75 11.25V6.75C24.75 5.50125 23.7375 4.5 22.5 4.5H4.5C3.2625 4.5 2.26125 5.50125 2.26125 6.75V11.25C3.49875 11.25 4.5 12.2625 4.5 13.5C4.5 14.7375 3.49875 15.75 2.25 15.75V20.25C2.25 21.4875 3.2625 22.5 4.5 22.5H22.5C23.7375 22.5 24.75 21.4875 24.75 20.25V15.75C23.5125 15.75 22.5 14.7375 22.5 13.5C22.5 12.2625 23.5125 11.25 24.75 11.25ZM22.5 9.6075C21.1612 10.3837 20.25 11.8462 20.25 13.5C20.25 15.1538 21.1612 16.6163 22.5 17.3925V20.25H4.5V17.3925C5.83875 16.6163 6.75 15.1538 6.75 13.5C6.75 11.835 5.85 10.3837 4.51125 9.6075L4.5 6.75H22.5V9.6075ZM12.375 16.875H14.625V19.125H12.375V16.875ZM12.375 12.375H14.625V14.625H12.375V12.375ZM12.375 7.875H14.625V10.125H12.375V7.875Z" fill="white" />
                </svg>
                Vote
            </button>
        </div>
    )
}
